import axios from "axios";
import {
    SET_SIMULATOR_LIST_REQUEST,
    SET_SIMULATOR_LIST_SUCCESS,
    SET_SIMULATOR_LIST_ERROR,
    SET_MODEL_LIST_REQUEST,
    SET_MODEL_LIST_SUCCESS,
    SET_MODEL_LIST_ERROR,
    SET_FUSION_LIST_REQUEST,
    SET_FUSION_LIST_SUCCESS,
    SET_FUSION_LIST_ERROR,
    DELETE_SCENARIO_SUCCESS,
    DELETE_SCENARIO_REQUEST,
    DELETE_SCENARIO_ERROR,

} from "../../../../constants/CM/cm_open_loop/fusionDataCollection/dropDownModelConstants";

export const fetchSimulatorInfo = () => (dispatch) => {
    try {
        dispatch({ type: SET_SIMULATOR_LIST_REQUEST });
        axios({
            url: `/cm/close_loop/carmaker_simulator_record`,
            method: "GET",
        }).then((response) => {
            if (response && response.status === 200) {
                dispatch({
                    type: SET_SIMULATOR_LIST_SUCCESS,
                    simulatorListInfo: response.data,
                });
            } else {
                dispatch({
                    type: SET_SIMULATOR_LIST_ERROR,
                    payload: "Error occured while fetching the simulator list",
                });
            }
        }).catch((error) => {
            if (
                Object.prototype.hasOwnProperty.call(error, "response") &&
                Object.prototype.hasOwnProperty.call(error.response, "data") &&
                Object.prototype.hasOwnProperty.call(error.response.data, "message")
            ) {
                dispatch({
                    type: SET_SIMULATOR_LIST_ERROR,
                    payload: error.response.data.message,
                });
            } else {
                dispatch({
                    type: SET_SIMULATOR_LIST_ERROR,
                    payload: "Something Went Wrong, Please Try Again!!",
                });
            }
        });
    } catch (error) {
        console.log("error msg", error);
        const errorMsg = error.message || "Error occurred while fetching this request!";
        dispatch({ type: SET_SIMULATOR_LIST_ERROR, payload: errorMsg });
    }
};

export const fetchModelInfo = (payload) => (dispatch) => {
    try {
        dispatch({ type: SET_MODEL_LIST_REQUEST });
        axios({
            url: `/close_loop/fetch-carmaker_model_record`,
            method: "GET",
            data: { simulator_name: payload },
        })
            .then((response) => {
                if (response && response.status === 200) {
                    
                    dispatch({
                        type: SET_MODEL_LIST_SUCCESS,
                        modelListInfo: response.data,
                    });
                } else {
                    dispatch({
                        type: SET_MODEL_LIST_ERROR,
                        payload: "Error occured while fetching the modal list",
                    });
                }
            })
            .catch((error) => {
                if (
                    Object.prototype.hasOwnProperty.call(error, "response") &&
                    Object.prototype.hasOwnProperty.call(error.response, "data") &&
                    Object.prototype.hasOwnProperty.call(error.response.data, "message")
                ) {
                    dispatch({
                        type: SET_MODEL_LIST_ERROR,
                        payload: error.response.data.message,
                    });
                } else {
                    dispatch({
                        type: SET_MODEL_LIST_ERROR,
                        payload: "Something Went Wrong, Please Try Again!!",
                    });
                }
            });
    } catch (error) {
        console.log("error msg", error);
        const errorMsg = error.message || "Error occurred while fetching this request!";
        dispatch({ type: SET_MODEL_LIST_ERROR, payload: errorMsg });
    }
};
//for fetching the fusion data list api
export const fetchFusionCarMakerListInfo = (pageNum = 1) => (dispatch) => {
    console.log(pageNum,"kkk")
    try {
        dispatch({ type: SET_FUSION_LIST_REQUEST });
        axios({
            url: `/cm/open_loop/list-files`,
            method: "POST",
            data: pageNum,
        })
            .then((response) => {
                if (response && response.status === 200) {
                    dispatch({
                        type: SET_FUSION_LIST_SUCCESS,
                        variationListInfo: response.data,
                    });
                } else {
                    dispatch({
                        type: SET_FUSION_LIST_ERROR,
                        payload: "Error occurred while fetching the variation list",
                    });
                }
            })
            .catch((error) => {
                let errorMsg = "Something Went Wrong, Please Try Again!!";
                if (
                    Object.prototype.hasOwnProperty.call(error, "response") &&
                    Object.prototype.hasOwnProperty.call(error.response, "data") &&
                    Object.prototype.hasOwnProperty.call(error.response.data, "message")
                ) {
                    errorMsg = error.response.data.message;
                }
                dispatch({
                    type: SET_FUSION_LIST_ERROR,
                    payload: errorMsg,
                });
            });
    } catch (error) {
        const errorMsg = error.message || "Error occurred while fetching this request!";
        dispatch({ type: SET_FUSION_LIST_REQUEST, payload: errorMsg });
    }
};
//scenario Details  feching apl
export const fetchVariationCarMakerListInfoDetails = (payload, page = 1) => {
    console.log(payload, "000")
    return axios({
        url: `/cm_close_loop/list_version_scenarios`,
        method: "POST",
        data: payload,
    })
        .then((response) => {

            return response.data;
        })
        .catch((error) => {
            if (
                Object.prototype.hasOwnProperty.call(error, "response") &&
                Object.prototype.hasOwnProperty.call(error.response, "data") &&
                Object.prototype.hasOwnProperty.call(error.response.data, "message")
            ) {
                return Promise.reject(error);
            } else {
                return Promise.reject({
                    response: {
                        data: {
                            message: "Error in fetching pagination info",
                        },
                    },
                });
            }
        });
};


//delete scenario implementation
export const deleteScenario = (scenarioUuid) => (dispatch) => {
    return new Promise((resolve, reject) => {
        try {
            dispatch({ type: DELETE_SCENARIO_REQUEST });

            axios({
                url: "/cm/close_loop/delete-carmaker-scenario",
                method: "POST",
                data: scenarioUuid,
            })
                .then((response) => {
                    console.log("Delete scenario response:", response.data);

                    if (response.status === 200) {
                        dispatch({
                            type: DELETE_SCENARIO_SUCCESS,
                            payload: response.data.message,
                        });
                        // No need to reload the page, as we are only soft-deleting
                        resolve(response.data.message);
                    } else {
                        const errorMsg = "An error occurred while deleting the scenario.";
                        dispatch({ type: DELETE_SCENARIO_ERROR, payload: errorMsg });
                        reject(errorMsg);
                    }
                })
                .catch((error) => {
                    console.error("Error deleting scenario:", error);

                    let errorMsg = "An error occurred while deleting the scenario.";

                    if (error.response) {
                        if (error.response.status === 404 && error.response.data.message) {
                            errorMsg = error.response.data.message;
                        }
                        // Add more conditions to handle other error cases if needed
                    }

                    dispatch({ type: DELETE_SCENARIO_ERROR, payload: errorMsg });
                    reject(errorMsg);
                });
        } catch (error) {
            console.error("Error deleting scenario:", error);
            const errorMsg = error.message || "An error occurred while deleting the scenario.";
            dispatch({ type: DELETE_SCENARIO_ERROR, payload: errorMsg });
            reject(errorMsg);
        }
    });
};
export const addDataToApprovedBucket = (payload) => {
    console.log(payload, '000')
    return (dispatch) => {

        axios.post('/cm/open_loop/move-file', payload)
            .then(response => {

                dispatch({ type: 'ADD_DATA_TO_APPROVED_BUCKET_SUCCESS', payload: response.data });
            })
            .catch(error => {

                dispatch({ type: 'ADD_DATA_TO_APPROVED_BUCKET_FAILURE', error: error.message });
            });
    };
};